module.exports = __webpack_public_path__ + "static/media/drone.27f42277.png";